import { render, staticRenderFns } from "./workMultiManage.vue?vue&type=template&id=56d7d355&"
import script from "./workMultiManage.vue?vue&type=script&lang=js&"
export * from "./workMultiManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports